import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserCategory = createAsyncThunk(
    '/add/addUserCategory',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-category`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserCategory = response.data;
            // console.log(addUserBank, '@@@')

            if (addUserCategory.success === true) {
                toast.success(addUserCategory?.message);
                return addUserCategory;
            } else {
                // console.log(addUserBank.message, "&&&&")
                throw new Error(addUserCategory.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserCategorySlice = createSlice({
    name: "addUserCategory",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserCategory.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserCategory.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserCategorySlice.reducer;